import { render, staticRenderFns } from "./BookfaceCreate.vue?vue&type=template&id=24d88e26&scoped=true&"
import script from "./BookfaceCreate.vue?vue&type=script&lang=js&"
export * from "./BookfaceCreate.vue?vue&type=script&lang=js&"
import style0 from "./BookfaceCreate.vue?vue&type=style&index=0&id=24d88e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d88e26",
  null
  
)

export default component.exports